module.exports = __webpack_public_path__ + "static/media/page08_two_girl.f1fc8ddf.png";